var map = {
	"./AiOptimize.svg": 48834,
	"./addteam.svg": 89997,
	"./adduser.svg": 17123,
	"./ai-edit-active.svg": 57439,
	"./ai-edit-hover.svg": 13929,
	"./ai-edit.svg": 868,
	"./ai-image-active.svg": 47862,
	"./ai-image-hover.svg": 52766,
	"./ai-image.svg": 80919,
	"./alipay-sele.svg": 67385,
	"./all-apps-active.svg": 89130,
	"./all-apps-hover.svg": 33818,
	"./all-apps.svg": 18355,
	"./btn-icon.svg": 25087,
	"./case-title.svg": 29456,
	"./clothes-replace-active.svg": 10591,
	"./clothes-replace-hover.svg": 75273,
	"./clothes-replace.svg": 96708,
	"./collection-icon.svg": 39757,
	"./collection.svg": 67433,
	"./collectioned.svg": 49862,
	"./color.svg": 54958,
	"./comment-like.svg": 92472,
	"./comment.svg": 83348,
	"./copy.svg": 78838,
	"./creation-center-active.svg": 13239,
	"./creation-center-hover.svg": 66273,
	"./creation-center.svg": 87532,
	"./customer-service-active.svg": 23694,
	"./customer-service-hover.svg": 74294,
	"./customer-service.svg": 10783,
	"./cutout-active.svg": 5460,
	"./cutout-hover.svg": 34580,
	"./cutout.svg": 89897,
	"./del.svg": 46900,
	"./document.svg": 21346,
	"./download.svg": 15253,
	"./dropdown-collect.svg": 35619,
	"./dropdown-copy.svg": 38396,
	"./dropdown-delete.svg": 53070,
	"./dropdown-download.svg": 92619,
	"./dropdown-share.svg": 96496,
	"./edit-icon-user.svg": 42551,
	"./edit-icon.svg": 43473,
	"./folder-icon-active.svg": 11572,
	"./folder-icon.svg": 82537,
	"./generate.svg": 99612,
	"./history.svg": 61991,
	"./hisup.svg": 68564,
	"./home-active.svg": 74339,
	"./home-hover.svg": 27157,
	"./home.svg": 49504,
	"./img-to-a.svg": 87882,
	"./img-to-v.svg": 48485,
	"./imgup.svg": 29189,
	"./inspire-assistant-active.svg": 37977,
	"./inspire-assistant-hover.svg": 50011,
	"./inspire-assistant.svg": 4874,
	"./invitation.svg": 27108,
	"./library.svg": 8354,
	"./like-btn-icon.svg": 88587,
	"./like-btn-iconed.svg": 3528,
	"./like-icon.svg": 90130,
	"./local.svg": 99230,
	"./locup.svg": 33062,
	"./logout.svg": 52799,
	"./mange.svg": 30091,
	"./me.svg": 59879,
	"./model-generate-active.svg": 65731,
	"./model-generate-hover.svg": 51189,
	"./model-generate.svg": 48960,
	"./more-active-icon.svg": 13365,
	"./more-icon.svg": 65916,
	"./password.svg": 39902,
	"./personal-center-active.svg": 15072,
	"./personal-center-hover.svg": 15320,
	"./personal-center.svg": 77389,
	"./preview-tips.svg": 11134,
	"./product-replace-active.svg": 97180,
	"./product-replace-hover.svg": 51644,
	"./product-replace.svg": 52321,
	"./product-retouch-active.svg": 88808,
	"./product-retouch-hover.svg": 5440,
	"./product-retouch.svg": 93797,
	"./project.svg": 11280,
	"./publish-active.svg": 20469,
	"./publish-hover.svg": 30079,
	"./publish.svg": 49550,
	"./reanalyze.svg": 19086,
	"./ref-to-a.svg": 80952,
	"./ref-to-v.svg": 64807,
	"./say.svg": 47770,
	"./scene-active.svg": 37810,
	"./scene-hover.svg": 11810,
	"./scene.svg": 28107,
	"./service.svg": 59922,
	"./stat-icon.svg": 39319,
	"./team-project-active.svg": 26937,
	"./team-project-hover.svg": 31515,
	"./team-project.svg": 47402,
	"./team.svg": 71670,
	"./text-to-a.svg": 31168,
	"./text-to-v.svg": 55439,
	"./upgradevip.svg": 28372,
	"./upload-icon.svg": 78236,
	"./upload.svg": 29538,
	"./usercenter.svg": 30179,
	"./video-generate-active.svg": 52449,
	"./video-generate-hover.svg": 97699,
	"./video-generate.svg": 57954,
	"./vip-active.svg": 4913,
	"./vip-hover.svg": 30003,
	"./vip.svg": 71954,
	"./watermark-remove-active.svg": 94321,
	"./watermark-remove-hover.svg": 47699,
	"./watermark-remove.svg": 274,
	"./wechat-sele.svg": 79021,
	"./works-like.svg": 67183,
	"./works-liked.svg": 34305,
	"./个人中心-橙.svg": 72219,
	"./个人中心-白.svg": 16711,
	"./个人中心-黑.svg": 13059,
	"./客服-橙.svg": 54484,
	"./客服-白.svg": 68264,
	"./客服-黑.svg": 52732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;